var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('global-menu'),_c('f-default-header',{attrs:{"title":_vm.$t('pages.settings.subtitle.keywords'),"subtitle":_vm.$t('pages.settings.verticalActivityRel.subtitle.configRelation')}}),_c('word-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }